import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PortalContext = createContext(null);

/** Date cross-proiect ale clientului (sinteză) — folosite de Acasă, sidebar (badge decizii) și modalul PM. */
export function PortalProvider({ children }) {
  const { user } = useAuth();
  const isClient = user && typeof user === "object" && user.role === "client";
  const [overview, setOverview] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isClient) return;
    setLoading(true); setError(null);
    try { const { data } = await api.get("/client/overview"); setOverview(data); }
    catch (e) { setError(e); }
    finally { setLoading(false); }
  }, [isClient]);

  useEffect(() => { if (isClient) refresh(); else setOverview(null); }, [isClient, refresh]);

  return (
    <PortalContext.Provider value={{ overview, loading, error, refresh, pendingDecisions: overview?.stats?.pending_decisions || 0 }}>
      {children}
    </PortalContext.Provider>
  );
}

export function usePortal() {
  return useContext(PortalContext) || { overview: null, loading: false, error: null, refresh: () => {}, pendingDecisions: 0 };
}
